module.exports = __webpack_public_path__ + "img/iconfont.24b5903c.svg";